import React from 'react';
import { Chip } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import SecurityIcon from '@mui/icons-material/Security';
import ShieldIcon from '@mui/icons-material/Shield';
import PublicIcon from '@mui/icons-material/Public';
import BusinessIcon from '@mui/icons-material/Business';

const CLASSIFICATION_CONFIG = {
  unclassified: { label: 'Unclassified', color: '#4caf50', bg: 'rgba(76,175,80,0.12)',   icon: PublicIcon   },
  internal:     { label: 'Internal',     color: '#2196f3', bg: 'rgba(33,150,243,0.12)',  icon: BusinessIcon },
  confidential: { label: 'Confidential', color: '#ff9800', bg: 'rgba(255,152,0,0.12)',   icon: ShieldIcon   },
  restricted:   { label: 'Restricted',   color: '#f44336', bg: 'rgba(244,67,54,0.12)',   icon: SecurityIcon },
  secret:       { label: 'SECRET',       color: '#b71c1c', bg: 'rgba(183,28,28,0.15)',   icon: LockIcon     },
};

const ClassificationBadge = ({ classification = 'unclassified', size = 'small', sx = {} }) => {
  const config = CLASSIFICATION_CONFIG[classification] || CLASSIFICATION_CONFIG.unclassified;
  const Icon = config.icon;
  return (
    <Chip
      size={size}
      icon={<Icon sx={{ color: `${config.color} !important`, fontSize: 14 }} />}
      label={config.label}
      sx={{
        color: config.color,
        bgcolor: config.bg,
        border: `1px solid ${config.color}40`,
        fontWeight: 700,
        fontSize: '0.7rem',
        letterSpacing: classification === 'secret' ? 1 : 0,
        ...sx,
      }}
    />
  );
};

export default ClassificationBadge;
export { CLASSIFICATION_CONFIG };
